import { render, staticRenderFns } from "./SessionExpireView.vue?vue&type=template&id=12c0b494&scoped=true&"
import script from "./SessionExpireView.vue?vue&type=script&lang=js&"
export * from "./SessionExpireView.vue?vue&type=script&lang=js&"
import style0 from "./SessionExpireView.vue?vue&type=style&index=0&id=12c0b494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0b494",
  null
  
)

export default component.exports